import React, { useState } from 'react';
import InputField from '@ingka/input-field';
import RadioButtonGroup from '@ingka/radio-button-group';
import Button from '@ingka/button';
import Accordion, { AccordionItem } from '@ingka/accordion';
import { manualValidate } from 'Action/manualValidateAction';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import FormField from '@ingka/form-field';
import { MANUAL_SUPPLIER_FETCH } from 'Action/types';
import './associatedDds.scss';
import { Select, Option } from '@ingka/select';
import calender from '@ingka/ssr-icon/paths/calendar';
import DatePickerComponent from 'pages/DatePickerComponent/datePickerComponent';

const AssociatedDds = ({ oldDdsRows, setOldDdsRows }) => {
  const [fetchMessageColor, setFetchMessageColor] = useState('');
  const [fetchMessage, setFetchMessage] = useState('');
  const [isFetch, setIsFetch] = useState(false);
  const [oldReferenceNumberValidate, setOldReferenceNumberValidate] = useState(false);
  const [oldVerificationNumberValidate, setOldVerificationNumberValidate] = useState(false);

  const handleActivityTypeChange = (index: number, value: string) => {
    const updatedRows = oldDdsRows.map((row, i) =>
      i === index ? { ...row, selectedActivityType: value } : row
    );
    setOldDdsRows(updatedRows);
  };
  const handleDdsdata = (index: number, field: any, value: any) => {
    if (field === 'oldDdsFilingDate' && value instanceof Date) {
      value = value.toISOString();
    }

    const newFormRows = oldDdsRows?.map((row: any, i: any) =>
      i === index ? { ...row, [field]: value } : row
    );
    setOldDdsRows([...newFormRows]);

    const updatedRow = newFormRows[index];
    const refLength = updatedRow.oldDdsFirstProduction?.length || 0;
    const verLength = updatedRow.oldDdsVerificationNumber?.length || 0;
    setOldReferenceNumberValidate(refLength > 14);
    setOldVerificationNumberValidate(verLength > 8);
    setIsFetch(refLength === 14 && verLength === 8);
  };
  const dispatch = useDispatch<AppDispatch>();

  const payload = {
    ddsReferenceNumber: oldDdsRows[0].oldDdsFirstProduction,
    ddsVerificationNumber: oldDdsRows[0].oldDdsVerificationNumber,
    ddsActivityType: oldDdsRows[0].oldDdsActivityType,
  };
  const handleFetch = async () => {
    try {
      const response = await dispatch(manualValidate(payload, MANUAL_SUPPLIER_FETCH));
      if (response && response?.status === 200) {
        setFetchMessage('Fetched Successfully');
        setFetchMessageColor('green');
      } else if (response && response.status === 400) {
        const errorMessage =
          typeof response.data === 'string'
            ? response.data
            : response.data?.message || 'Fetching failed';
        setFetchMessage(errorMessage);
        setFetchMessageColor('red');
      } else {
        setFetchMessageColor('Fetching failed: Unknown error');
      }
    } catch (error) {
      setFetchMessage('Not Valid DDS');
      setFetchMessageColor('red');
    }
  };

  return (
    <div>
      <Accordion>
        <AccordionItem title="DDS for first production" id="ddsproductaccordion" open>
          {oldDdsRows?.map((row, index) => (
            <div className="dds-tabs" key={index}>
              <FormField
                characterLimit={14}
                fieldHelper={{
                  id: 'helper-msg-id',
                }}
                shouldValidate={oldReferenceNumberValidate}
                valid={
                  row.oldDdsFirstProduction &&
                  (row.oldDdsFirstProduction.length >= 14 ||
                    !/^\d+$/.test(row.oldDdsFirstProduction))
                    ? 'error'
                    : false
                }
                validation={{
                  id: 'error-msg-id',
                  msg: 'Enter valid reference number',
                  type: 'error',
                }}
              >
                <InputField
                  style={{ marginRight: 10 }}
                  iconPosition="leading"
                  id={`product-name-${index}`}
                  type="text"
                  value={row.oldDdsFirstProduction}
                  onChange={(e) => handleDdsdata(index, 'oldDdsFirstProduction', e.target.value)}
                  label={index === 0 ? 'Associated DDS ref number' : ''}
                />
              </FormField>
              <FormField
                characterLimit={8}
                fieldHelper={{
                  id: 'helper-id',
                }}
                shouldValidate={oldVerificationNumberValidate}
                valid={
                  row.oldDdsVerificationNumber &&
                  (row.oldDdsVerificationNumber.length >= 8 ||
                    !/^\d+$/.test(row.oldDdsVerificationNumber))
                    ? 'error'
                    : false
                }
                validation={{
                  id: 'error-msg-id',
                  msg: 'DDS Number Should Be 13 Digits',
                  type: 'error',
                }}
              >
                <InputField
                  style={{ marginRight: 10 }}
                  iconPosition="leading"
                  id={`verification-number-${index}`}
                  type="text"
                  value={row.oldDdsVerificationNumber}
                  onChange={(e) => handleDdsdata(index, 'oldDdsVerificationNumber', e.target.value)}
                  label={index === 0 ? 'Verification number' : ''}
                  required={!!row.oldDdsFirstProduction}
                />
              </FormField>
              <div style={{ display: 'flex', flexDirection: 'row', gap: 16, paddingBottom: 42 }}>
                <Select
                  id={`activitytype-${index}`}
                  label="Activity type"
                  value={row.oldDdsActivityType}
                  onChange={(e) => handleDdsdata(index, 'oldDdsActivityType', e.target.value)}
                  style={{ width: 'auto' }}
                >
                  <Option value="EXPORT" name="EXPORT" />
                  <Option value="IMPORT" name="IMPORT" />
                  <Option value="TRADE" name="TRADE" />
                  <Option value="DOMESTIC" name="DOMESTIC" />
                </Select>
                <div style={{ position: 'relative', display: 'inline-block', paddingTop: 3 }}>
                  <DatePickerComponent
                    heading="old DDS filing date"
                    selectedDate={row.oldDdsFilingDate ? new Date(row.oldDdsFilingDate) : null}
                    onChange={(formattedDate) =>
                      handleDdsdata(index, 'oldDdsFilingDate', formattedDate)
                    }
                    format="iso"
                  />
                </div>
              </div>
              <>
                <Button
                  onClick={handleFetch}
                  size="xsmall"
                  type="emphasised"
                  disabled={!isFetch}
                  style={{ paddingBottom: 48 }}
                >
                  Fetch
                </Button>
                <div
                  style={{
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    paddingBottom: 60,
                  }}
                >
                  {fetchMessage && <div style={{ color: fetchMessageColor }}>{fetchMessage}</div>}
                </div>
              </>
            </div>
          ))}
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default AssociatedDds;
